export default __webpack_public_path__ + "static/media/Centralize.28209815.png";